import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-h5" }

import { VProgressLinear } from 'vuetify/components'

export default /*#__PURE__*/_defineComponent({
  __name: 'ToolCard',
  props: {
    title: {},
    executing: { type: Boolean },
    progress: {},
    total: {},
    remainingMs: {},
    buttonText: {}
  },
  emits: ["execute"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "pa-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "default")
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  }),
                  _createVNode(_component_v_row, { align: "center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          (_ctx.executing)
                            ? (_openBlock(), _createBlock(_unref(VProgressLinear), {
                                key: 0,
                                "model-value": _ctx.progress,
                                max: _ctx.total
                              }, null, 8, ["model-value", "max"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (_ctx.executing)
                        ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("Осталось " + _toDisplayString(((_ctx.remainingMs ?? 0) / 1000).toFixed(1)) + " сек", 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_col, { cols: "auto" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            loading: _ctx.executing,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('execute')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.buttonText ?? 'Выполнить'), 1)
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})